export default __webpack_public_path__ + "static/BayswaterCarousel_0007-853857f9c94dafa372213820a23e61ee.jpg";